import * as React from "react";
import { Route, Switch } from "react-router-dom";

import Users from "./Wallet.Users";
import AddFunds from "./Wallet.AddFunds";
import WalletList from "./Wallet.List";
import WithdrawalsList from "./Wallet.WithdrawalRequests.List";
import WithdrawalsSummary from "./Wallet.WithdrawalRequests.Summary";

const Wallet = props => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/wallets"
      render={routerProps => <WalletList {...{ ...props, ...routerProps }} />}
    />

    <Route
      exact={true}
      path="/snapscan/wallets/:wallet_name/users"
      render={routerProps => (
        <Users
          name={routerProps.match.params.wallet_name}
          {...{ ...props, ...routerProps }}
        />
      )}
    />

    <Route
      exact={true}
      path="/snapscan/wallets/:wallet_name/add_funds"
      render={routerProps => <AddFunds {...{ ...props, ...routerProps }} />}
    />

    <Route
      exact={true}
      path="/snapscan/vouchers"
      render={routerProps => <WalletList {...{ ...props, ...routerProps }} />}
    />

    <Route
      exact={true}
      path="/snapscan/vouchers/:wallet_name/users"
      render={routerProps => (
        <Users
          name={routerProps.match.params.wallet_name}
          {...{ ...props, ...routerProps }}
        />
      )}
    />

    <Route
      exact={true}
      path="/snapscan/wallet_withdrawals"
      render={routerProps => (
        <WithdrawalsList {...{ ...props, ...routerProps }} />
      )}
    />

    <Route
      exact={true}
      path="/snapscan/wallet_withdrawals/:id/summary"
      render={routerProps => (
        <WithdrawalsSummary {...{ ...props, ...routerProps }} />
      )}
    />
  </Switch>
);

export default Wallet;
